import { Host, h } from "@stencil/core";
export class GxgShortcuts {
    constructor() {
        this.src = undefined;
        this.showKey = "F10";
        this.suspend = false;
        this.showTooltip = false;
        this.show = false;
    }
    componentDidLoad() {
        this.showTooltip = true;
    }
    render() {
        return (h(Host, null, h("ch-shortcuts", { suspend: this.suspend, src: this.src, showKey: this.showKey })));
    }
    static get is() { return "gxg-shortcuts"; }
    static get originalStyleUrls() {
        return {
            "$": ["shortcuts.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["shortcuts.css"]
        };
    }
    static get properties() {
        return {
            "src": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The URL of the shortcut definitions."
                },
                "attribute": "src",
                "reflect": false
            },
            "showKey": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"F10\"",
                    "resolved": "\"F10\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "show-key",
                "reflect": false,
                "defaultValue": "\"F10\""
            },
            "suspend": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "suspend",
                "reflect": false,
                "defaultValue": "false"
            },
            "showTooltip": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "show-tooltip",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "show": {}
        };
    }
}
//# sourceMappingURL=shortcuts.js.map
